import { ColoursObj, Icon } from '@eventr/common-storybook'
import { FC } from 'react'
import { Chip } from '@mui/material'

type THotelMealCardProps = {
    meanStr: string
}

export const HotelMealCard: FC<THotelMealCardProps> = ({ meanStr }) => {
    if (meanStr.includes('No meals')) {
        return (
            <Chip
                style={{
                    borderRadius: '4px',
                    backgroundColor: ColoursObj.states.errorLight,
                    color: ColoursObj.shades.shade1,
                }}
                label={meanStr}
                icon={
                    <Icon name="Meal" iconColour={ColoursObj.shades.shade1} />
                }
            />
        )
    }
    return (
        <Chip
            style={{
                borderRadius: '4px',
                backgroundColor: ColoursObj.states.successLight,
                color: ColoursObj.shades.shade1,
            }}
            label={meanStr}
            icon={<Icon name="Meal" iconColour={ColoursObj.shades.shade1} />}
        />
    )
}
